export default "/images/9cb9e558dc3197422f4fd0afffba5c30.avif";